import { render, staticRenderFns } from "./NewEditCircuitoNotasPage.vue?vue&type=template&id=73c54db4&scoped=true"
import script from "./NewEditCircuitoNotasPage.vue?vue&type=script&lang=js"
export * from "./NewEditCircuitoNotasPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditCircuitoNotasPage.vue?vue&type=style&index=0&id=73c54db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c54db4",
  null
  
)

export default component.exports